// src/features/services/components/ServiceUsageSection.tsx
import { EmptyState } from '../../../app/components/foundation';

/**
 * Usage section — future-ready presentation area. No usage metrics
 * exist on `Service` today, so this renders a neutral placeholder
 * instead of any invented/mock usage numbers.
 */
export function ServiceUsageSection() {
  return <EmptyState message="آمار مصرف این سرویس پس از یکپارچه‌سازی با Core Services در دسترس خواهد بود." />;
}
